import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCheckTicketDrawn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 65,
	viewBox: "0 0 64 65",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M40.7401 37.5258C41.5644 39.7985 42.4369 42.2024 43.2772 44.224C41.544 44.9475 40.2312 46.1133 39.9999 47.8483C39.7686 49.5834 40.4248 50.1843 41.5036 51.7425C37.3817 53.6331 29.4144 57.6436 29.1482 57.7657C28.5991 56.3347 28.5631 53.8871 26.6305 53.2722C24.6979 52.6572 22.9818 53.4985 21.9462 54.4193C21.2171 52.8297 18.4799 44.6062 15.9061 39.2553C13.3322 33.9045 13.0336 33.8981 9.62601 26.4689C11.1673 25.8096 12.7894 24.1361 12.7989 22.8729C12.8085 21.6097 12.8091 19.9513 11.1038 18.7474L25.2438 13.1369C25.2438 14.3799 25.495 15.3227 25.8626 16.0711",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.4746 36.9151C32.0933 37.1019 30.6045 37.6138 28.3675 38.519C26.6873 39.1988 25.2954 40.0477 24.0761 40.5353",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.7143 42.3816C32.4556 42.5314 29.5285 43.8377 28.2759 44.6273",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.4393 32.7193L18.1786 32.8173",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7005 30.9055L22.459 30.9928",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.7991 29.1555L26.5428 29.2511",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.5947 19.3743C30.8564 20.6041 28.934 23.5003 28.4678 24.0153C29.6119 25.1843 32.0277 27.0646 33.2666 28.5943C34.8152 30.5065 35.8279 32.4409 36.9387 34.7347L43.0996 34.7347C45.5692 25.8525 50.237 17.921 54.0534 16.5334C53.3099 14.2042 51.2683 9.21495 50.4846 9.4458C40.7207 12.322 38.9997 24.5255 38.9997 24.5255L32.5947 19.3743Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.5151 16.6739C29.7768 17.9037 27.8545 20.7998 27.3882 21.3148C28.5323 22.4839 30.9481 24.3642 32.187 25.8939C33.7356 27.8061 34.7483 29.7405 35.8591 32.0343L42.02 32.0343C44.4896 23.152 49.1574 15.2206 52.9738 13.833C52.2303 11.5038 50.1887 6.51453 49.405 6.74538C39.6411 9.62158 37.9201 21.8251 37.9201 21.8251L31.5151 16.6739Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCheckTicketDrawn;
